const host = {
  socketServer: 'https://chat.sunshineservice.vn:3001',
  authServer: 'https://idp-dev.unicloudgroup.com.vn/realms/realm_unihrm',
  apiServer: 'https://dev.api.unicloudgroup.com.vn',
  apAssetServer: 'https://dev.api.asset.unicloudgroup.com.vn',
  apiConfigServer: 'https://dev.api.hrmconfig.unicloudgroup.com.vn',
  apiCoreServer: 'https://dev.api.core.unicloudgroup.com.vn',
  apiHrmServer: 'https://dev.api.hrm.unicloudgroup.com.vn',
  uploadServer: 'https://data.sunshinegroup.vn/api/v1/FileHandler',
  // cloudFunction: 'https://us-central1-sunshine-super-app.cloudfunctions.net' //dev
  cloudFunction: 'https://asia-northeast1-sunshine-app-production.cloudfunctions.net' //product
};

const authenSettings = {
  authority: host.authServer,
  client_id: 'web_uni_asset_dev',
  redirect_uri: 'https://dev-web-asset.unicloudgroup.com.vn/auth-callback',
  post_logout_redirect_uri: 'https://dev-web-asset.unicloudgroup.com.vn',
  response_type: 'id_token token',
  scope: 'openid profile',
  filterProtocolClaims: true,
  loadUserInfo: true,
  automaticSilentRenew: true,
  silent_redirect_uri: 'https://dev-web-asset.unicloudgroup.com.vn/silent-refresh.html'

};


const firebase = {
  apiKey: 'AIzaSyAb3orVc8nnGT0L2JgbdzXrRND393mFiFU',
  authDomain: 'sunshine-app-production.firebaseapp.com',
  databaseURL: 'https://sunshine-app-production.firebaseio.com',
  projectId: 'sunshine-app-production',
  storageBucket: 'sunshine-app-production.appspot.com'
  // apiKey: 'AIzaSyAczqJoNnTDPPLktoPtQ694IH38sR8wX6w',
  // authDomain: 'sunshine-super-app.firebaseapp.com',
  // databaseURL: 'https://sunshine-super-app.firebaseio.com',
  // projectId: 'sunshine-super-app',
  // storageBucket: 'sunshine-super-app.appspot.com',
  // messagingSenderId: '504497996884',
  // appId: '1:504497996884:web:e07732b704e759529819c1',
};

export const environment = {
  production: true,
  apiBase: host.apiServer,
  apiHrmBase: host.apiHrmServer,
  apiConfigBase: host.apiConfigServer,
  apiCoreBase: host.apiCoreServer,
  apiAssetBase: host.apAssetServer,
  socketServer: host.socketServer,
  cloudFunctionServer: host.cloudFunction,
  authenSettings: authenSettings,
  uploadServer: host.uploadServer,
  firebase
};











// const host = {
//   socketServer: 'https://chat.sunshineservice.vn:3001',
//   authServer: 'https://idp.unicloudgroup.net/realms/realm_uni_hrm',
//   apiServer: 'https://api.sunshinegroup.vn',
//   apAssetServer: 'https://api-uni-asset.sunshinetech.com.vn',
//   apiHrmServer: 'https://api-unihrm.sunshinetech.com.vn',
//   apiConfigServer: 'https://api-unihrmadmin.sunshinetech.com.vn',
//   apiCoreServer: 'https://apicore.sunshinetech.com.vn',
//   uploadServer: 'https://data.sunshinegroup.vn/api/v1/FileHandler',
//   // cloudFunction: 'https://us-central1-sunshine-super-app.cloudfunctions.net' //dev
//   cloudFunction: 'https://asia-northeast1-sunshine-app-production.cloudfunctions.net' //product
// };

// const authenSettings = {
//   authority: host.authServer,
//   client_id: 'web_uni_asset',
//   redirect_uri: 'https://uni-asset.sunshineapp.vn/auth-callback',
//   post_logout_redirect_uri: 'https://uni-asset.sunshineapp.vn',
//   response_type: 'id_token token',
//   scope: 'openid profile',
//   filterProtocolClaims: true,
//   loadUserInfo: true,
//   automaticSilentRenew: true,
//   silent_redirect_uri: 'https://uni-asset.sunshineapp.vn/silent-refresh.html'

// };


// const firebase = {
//   apiKey: 'AIzaSyAb3orVc8nnGT0L2JgbdzXrRND393mFiFU',
//   authDomain: 'sunshine-app-production.firebaseapp.com',
//   databaseURL: 'https://sunshine-app-production.firebaseio.com',
//   projectId: 'sunshine-app-production',
//   storageBucket: 'sunshine-app-production.appspot.com'
//   // apiKey: 'AIzaSyAczqJoNnTDPPLktoPtQ694IH38sR8wX6w',
//   // authDomain: 'sunshine-super-app.firebaseapp.com',
//   // databaseURL: 'https://sunshine-super-app.firebaseio.com',
//   // projectId: 'sunshine-super-app',
//   // storageBucket: 'sunshine-super-app.appspot.com',
//   // messagingSenderId: '504497996884',
//   // appId: '1:504497996884:web:e07732b704e759529819c1',
// };

// export const environment = {
//   production: true,
//   apiBase: host.apiServer,
//   apiHrmBase: host.apiHrmServer,
//   apiConfigBase: host.apiConfigServer,
//   apiCoreBase: host.apiCoreServer,
//   apiAssetBase: host.apAssetServer,
//   socketServer: host.socketServer,
//   cloudFunctionServer: host.cloudFunction,
//   authenSettings: authenSettings,
//   uploadServer: host.uploadServer,
//   firebase
// };









